<template>
  <div>
    <md-dialog-confirm
      :md-active.sync="showModalInfo.visible"
      :md-title="showModalInfo.titulo"
      :md-content="showModalInfo.texto"
      md-confirm-text="Aceptar"
      md-cancel-text="Cancelar"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />
    <h1>
      <img
        src="https://img.icons8.com/external-xnimrodx-lineal-gradient-xnimrodx/64/000000/external-home-real-estate-xnimrodx-lineal-gradient-xnimrodx-2.png"
      /><b>SOLUCASA</b>
    </h1>
    <div class="form-group pull-left"></div>

    <div v-if="!loading && rol === 'ADMIN_MAIN'">
      <div class="panel panel-container md-elevation-24">
        <div class="row">
          <div class="col-xs-6 col-md-4 col-lg-4 no-padding">
            <div class="panel panel-teal panel-widget border-right">
              <div class="row no-padding">
                <em class="fa fa-xl fa-credit-card color-blue"></em>
                <div class="large">{{ pendientes }}</div>
                <div class="text">
                  <b>Tarjetas en proceso</b>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-md-4 col-lg-4 no-padding">
            <div class="panel panel-blue panel-widget border-right">
              <div class="row no-padding">
                <em class="fa fa-xl fa-credit-card color-orange"></em>
                <div class="large">{{ entregar }}</div>
                <div class="text">
                  <b>Tarjetas pendientes por entregar</b>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-6 col-md-4 col-lg-4 no-padding">
            <div class="panel panel-orange panel-widget border-right">
              <div class="row no-padding">
                <em class="fa fa-xl fa-users color-teal"></em>
                <div class="large">{{ clientes }}</div>
                <div class="text">
                  <b>Clientes</b>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--/.row-->
      </div>
      <div v-if="!loading && rol === 'ADMIN_MAIN'">
        <h4>
          <b>{{
            tecnicos.length === 0
              ? 'Consultando información...'
              : 'TÉCNICOS'
          }}</b>
        </h4>
        <div class="row">
          <div
            class="col-xs-6"
            v-for="(tecnico, index) in tecnicos"
            :key="index"
          >
            <div class="panel panel-default">
              <div
                class="panel-body easypiechart-panel md-elevation-24"
              >
                <div class="row" v-if="tecnico.rol === 'TECNICO'">
                  <h4 style="padding-top: 15px">
                    {{ `${tecnico.nombre} ${tecnico.apellidos}` }}
                  </h4>
                  <div class="col-md-7">
                    <div
                      class="easypiechart"
                      id="easypiechart-blue"
                      data-percent="92"
                    >
                      <img
                        style="height: 100px;"
                        :src="
                          tecnico.url_imagen != null
                            ? tecnico.url_imagen
                            : 'https://img.icons8.com/bubbles/100/000000/user.png'
                        "
                        alt="User Avatar"
                        class="img-circle"
                      />
                    </div>
                  </div>
                  <br />
                  <div class="col-md-5">
                    <a
                      href="#"
                      @click="
                        showModalDetail(
                          'asignadas',
                          tecnico.ordenes,
                          tecnico
                        )
                      "
                    >
                      <div class="text">
                        Tarjetas asignadas:
                        {{ tecnico.ordenes.length }}
                      </div>
                    </a>
                    <a
                      href="#"
                      @click="
                        showModalDetail(
                          'terminadas',
                          tecnico.ordenes,
                          tecnico
                        )
                      "
                    >
                      <div class="text">
                        Tarjetas terminadas:
                        {{
                          tecnico.ordenes.filter(
                            o => o.terminado === 1
                          ).length
                        }}
                      </div>
                    </a>
                    <a
                      href="#"
                      @click="
                        showModalDetail(
                          'proceso',
                          tecnico.ordenes,
                          tecnico
                        )
                      "
                    >
                      <div class="text">
                        Tarjetas en proceso:
                        {{
                          tecnico.ordenes.filter(
                            o => o.terminado === 0
                          ).length
                        }}
                      </div>
                    </a>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-md-7">
                    <h4 style="padding-top: 15px">
                      {{ `${tecnico.nombre} ${tecnico.apellidos}` }}
                    </h4>
                    <div
                      class="easypiechart"
                      id="easypiechart-blue"
                      data-percent="92"
                    >
                      <img
                        :src="
                          tecnico.url_imagen != null
                            ? tecnico.url_imagen
                            : 'https://img.icons8.com/bubbles/100/000000/user.png'
                        "
                        alt="User Avatar"
                        class="img-circle"
                      />
                    </div>
                  </div>
                  <br />
                  <div class="col-md-5">
                    <!-- <a href="#" @click="showModalDetail('asignadas', tecnico.ordenes, tecnico)"><div class="text">Tarjetas asignadas: {{tecnico.ordenes.length}}</div></a> -->
                    <a
                      href="#"
                      @click="
                        showModalDetail(
                          'analizadas',
                          tecnico.ordenes,
                          tecnico
                        )
                      "
                    >
                      <div class="text">
                        Tarjetas Analizadas:
                        {{ getTarjetasAnalizadas(tecnico.id) }}
                      </div>
                    </a>
                    <a
                      href="#"
                      @click="
                        showModalDetail(
                          'proceso',
                          tecnico.ordenes,
                          tecnico
                        )
                      "
                    >
                      <div class="text">
                        Tarjetas en proceso:
                        {{ tarjetasEnProcesoAnalisis(tecnico) }}
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--/.row-->
    </div>
    <div v-if="!loading && rol === 'TECNICO'">
      <div class="panel panel-container md-elevation-24">
        <div class="row">
          <div class="col-xs-6 col-md-3 col-lg-3 no-padding">
            <div class="panel panel-teal panel-widget border-right">
              <div class="row no-padding">
                <em class="fa fa-xl fa-credit-card color-blue"></em>
                <div class="large">{{ tarjetasEnProceso }}</div>
                <div class="text">Tarjetas en proceso</div>
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-md-3 col-lg-3 no-padding">
            <div class="panel panel-blue panel-widget border-right">
              <div class="row no-padding">
                <em class="fa fa-xl fa-credit-card color-orange"></em>
                <div class="large">{{ terminadasSin }}</div>
                <div class="text">
                  Tarjetas terminadas sin entregar
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-6 col-md-3 col-lg-3 no-padding">
            <div class="panel panel-orange panel-widget border-right">
              <div class="row no-padding">
                <em class="fa fa-xl fa-credit-card color-green"></em>
                <div class="large">{{ terminadasEntregadas }}</div>
                <div class="text">Tarjetas terminadas entregadas</div>
              </div>
            </div>
          </div>

          <div class="col-xs-6 col-md-3 col-lg-3 no-padding">
            <div class="panel panel-orange panel-widget border-right">
              <div class="row no-padding">
                <em class="fa fa-xl fa-credit-card color-blue"></em>
                <div class="large">{{ totalAsignadas }}</div>
                <div class="text">Total asignadas</div>
              </div>
            </div>
          </div>
        </div>
        <!--/.row-->
      </div>
    </div>
    <div v-if="!loading && rol === 'ANALISTA'">
      <div class="panel panel-container md-elevation-24">
        <div class="row">
          <div class="col-xs-6 col-md-4 col-lg-4 no-padding">
            <div class="panel panel-teal panel-widget border-right">
              <div class="row no-padding">
                <em class="fa fa-xl fa-credit-card color-blue"></em>
                <div class="large">{{ tarjetasEnProceso }}</div>
                <div class="text">Tarjetas en proceso</div>
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-md-4 col-lg-4 no-padding">
            <div class="panel panel-blue panel-widget border-right">
              <div class="row no-padding">
                <em class="fa fa-xl fa-credit-card color-orange"></em>
                <div class="large">{{ totalAnalizadas }}</div>
                <div class="text">Tarjetas analizadas</div>
              </div>
            </div>
          </div>

          <div class="col-xs-6 col-md-4 col-lg-4 no-padding">
            <div class="panel panel-orange panel-widget border-right">
              <div class="row no-padding">
                <em class="fa fa-xl fa-credit-card color-blue"></em>
                <div class="large">{{ totalAsignadas }}</div>
                <div class="text">Total asignadas</div>
              </div>
            </div>
          </div>
        </div>
        <!--/.row-->
      </div>
    </div>
    <div id="table-info" hidden>
      <!-- <table>
      <tr>
        <table-head md-numeric>ID</table-head>
        <table-head>FECHA INGRESO</table-head>
        <table-head>SERVICIO</table-head>
        <table-head>ESTADO</table-head>
        <table-head>VALOR</table-head>
      </tr>
      <tr v-for="(orden, index) in dataTable" :key="index">
         <table-cell>{{orden.id}}</table-cell>
         <table-cell>{{orden.created_at}}</table-cell>
         <table-cell>{{orden.servicio.toUpperCase()}}</table-cell>
         <table-cell>{{JSON.parse(orden.estado).estado.toUpperCase()}}</table-cell>
         <table-cell>{{orden.precio | currency}}</table-cell>
      </tr>
      </table>-->
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
  name: 'general',
  components: {
    Loading,
  },
  computed: mapState(['rol', 'usuarioId']),
  data() {
    return {
      loading: false,
      pendientes: 0,
      entregar: 0,
      clientes: 0,
      tarjetasEnProceso: 0,
      terminadasSin: 0,
      terminadasEntregadas: 0,
      totalAsignadas: 0,
      tecnicos: [],
      analistas: [],
      totalAnalizadas: 0,
      ordenesAnalista: [],
      showModalInfo: {
        visible: false,
        titulo: '',
        texto: '',
      },
      mensajes: {
        activo: false,
      },
      dataTable: [],
      tecnico: '',
    };
  },
  created() {
    this.rol === 'ADMIN_MAIN'
      ? this.getInfoAdmin()
      : this.rol === 'TECNICO'
      ? this.getInfoTecnico()
      : this.getInfoAnalista();
  },
  watch: {},
  mounted() {},
  methods: {
    onCancel() {
      this.dataTable = [];
    },
    getTarjetasAnalizadas(tecnicoId) {
      return this.analistas.filter(a => a.tecnicoId === tecnicoId)
        .length;
    },
    showModalDetail(tipo, ordenes, tecnico) {
      this.dataTable = [];
      switch (tipo) {
        case 'asignadas':
          this.dataTable = ordenes;
          break;
        case 'terminadas':
          this.dataTable = ordenes.filter(o => o.terminado === 1);
          break;
        case 'proceso':
          this.dataTable = ordenes.filter(o => o.terminado === 0);
          break;
        case 'analizadas':
          this.dataTable = this.analistas.filter(
            a => a.tecnicoId === tecnico.id
          );

          break;
      }
      let table = document.getElementById('table-info');
      let cabeceraTable =
        '<table class="table">' +
        '<tr>' +
        '<tr>' +
        '<th scope="col">O.S</th>' +
        '<th scope="col">FECHA INGRESO</th>' +
        '<th scope="col">CLIENTE</th>' +
        '<th scope="col">SERVICIO</th>' +
        '<th scope="col">ESTADO</th>' +
        '<th scope="col">VALOR</th>' +
        '</tr>' +
        '</tr>' +
        '<tbody>';
      let body = '';
      if (tipo != 'analizadas') {
        this.dataTable.forEach((orden, index) => {
          body +=
            '<tr>' +
            '<th>' +
            orden.id +
            '</th>' +
            '<th>' +
            orden.created_at +
            '</th>' +
            '<th>' +
            orden.cliente.nombre +
            ' ' +
            orden.cliente.apellidos +
            '</th>' +
            '<th>' +
            orden.servicio.toUpperCase() +
            '</th>' +
            '<th>' +
            JSON.parse(orden.estado).estado.toUpperCase() +
            '</th>' +
            '<th>' +
            orden.precio +
            '</th>' +
            '</tr>';
        });
      } else {
        this.dataTable.forEach((orden, index) => {
          body +=
            '<tr>' +
            '<th>' +
            orden.ordenId +
            '</th>' +
            '<th>' +
            orden.created_at +
            '</th>' +
            '<th>' +
            orden.nombre +
            ' ' +
            orden.apellidos +
            '</th>' +
            '<th>' +
            orden.servicio.toUpperCase() +
            '</th>' +
            '<th>' +
            JSON.parse(orden.estado).estado.toUpperCase() +
            '</th>' +
            '<th>' +
            orden.precio +
            '</th>' +
            '</tr>';
        });
      }
      let htmlCompleto = cabeceraTable + body + '</tbody></table>';
      table.innerHTML = htmlCompleto;
      this.showModalInfo.titulo = `${tecnico.nombre} ${
        tecnico.apellidos
      } - ${this.dataTable.length} TARJETAS ${tipo.toUpperCase()}`;
      this.showModalInfo.texto = table.innerHTML;
      this.showModalInfo.visible = true;
    },
    onConfirm() {
      this.dataTable = [];
    },
    tarjetasEnProcesoAnalisis(tecnico) {
      let ordenes = tecnico.ordenes;
      let count = 0;
      ordenes.forEach(element => {
        let proceso = JSON.parse(element.proceso);
        if (!proceso) {
          count++;
        } else {
          proceso.proceso === 'Análisis' &&
          !proceso.analisis.terminado
            ? count++
            : '';
        }
      });
      return count;
    },
    showModal() {
      // const {value: marca} = Swal.fire({
      // title: 'Digita el nombre de la marca',
      // input: 'text',
      // inputPlaceholder: 'Ingresa nombre de la marca',
      // confirmButtonText:'Guardar'
      // }).then((response)=>{
      //     response.value != undefined || response.value != null ? this.saveInformation(response.value) : ''
      // })
    },
    getInfoAdmin() {
      // this.loading = true;
      this.getContadores();
      ServiceApi.get('/orden/getInfoAdmin')
        .then(response => {
          // console.log('RESPUESTA INFO:::', response.data);
          let data = response.data.data;
          this.tecnicos = data.tecnicos;
          this.analistas = data.analistas;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.$router.push('/');
        });
    },
    getContadores() {
      ServiceApi.get('/orden/getContadores')
        .then(response => {
          let data = response.data.data;
          this.clientes = data.cantidadClientes;
          this.pendientes = data.enProceso;
          this.entregar = data.pendientesEntrega;
        })
        .catch(err => {
          this.loading = false;
          this.$router.push('/');
        });
    },
    getInfoTecnico() {
      this.loading = true;
      let data = {
        userId: this.usuarioId,
      };
      ServiceApi.post('/orden/getInfoTecnico', data)
        .then(response => {
          // console.log('RESPUESTA:::', response)
          let data = response.data.data;
          this.tarjetasEnProceso = data.enProceso;
          this.terminadasSin = data.terminadas;
          this.terminadasEntregadas = data.termiandasEntregadas;
          this.totalAsignadas = data.totalAsignadas;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.$router.push('/');
        });
    },
    getInfoAnalista() {
      this.loading = true;
      let data = {
        userId: this.usuarioId,
      };
      ServiceApi.post('/orden/getInfoAnalista', data)
        .then(response => {
          // console.log('RESPUESTA:::', response)
          let data = response.data.data;
          this.tarjetasEnProceso = data.enProceso;
          this.totalAsignadas = data.totalAsignadas;
          this.totalAnalizadas = data.totalAnalizadas;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.$router.push('/');
        });
    },
  },
};
</script>
